import {
  sendGetRequest,
  sendPostRequest,
  useGetRequest,
} from "../../../Client";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Notyf } from "notyf";
import "notyf/notyf.min.css"; // for React, Vue and Svelte
import { Button, Table, Modal } from "flowbite-react";
import { Link } from "react-router-dom";
import { useState } from "react";
import CountryDropdown from "../../../Components/CountryDropdown";
import { useNavigate } from "react-router-dom";

export default function Users() {
  const [openModal, setOpenModal] = useState(false);
  const [inputs, setInputs] = useState({});

  const [main, setMain] = useState(false);
  const [finance, setFinance] = useState(false);
  const [compliance, setCompliance] = useState(false);

  const navigate = useNavigate();

  const { companyID } = useParams();

  const notyf = new Notyf({
    position: {
      x: "right",
      y: "top",
    },
  });

  const queryClient = useQueryClient();

  // loading users
  const { data: users, isLoading } = useQuery({
    queryFn: () => sendGetRequest("users/" + companyID, {}),
    queryKey: ["users"],
  });

  const areYouSure = (id) => {
    Swal.fire({
      title: "Are you sure?",
      showCancelButton: true,
      confirmButtonText: "Delete",
      confirmButtonColor: "#de3333",
    }).then((result) => {
      if (result.isConfirmed) {
        doDeleteMutation(id);
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };

  const deletedNotyf = () => {
    notyf.success({ message: "User deleted", background: "#de2016" });
  };

  // deleting user
  const userDelete = async (id) => {
    const res = await sendPostRequest("user/delete", {
      userID: id,
    });
    console.log(res);
  };

  const addedNotyf = () => {
    notyf.success("User added");
  };

  // adding user
  const userAdd = async (path, body) => {
    const res = await sendPostRequest(path, body);
    addedNotyf();
  };

  const { mutateAsync: doAddMutation } = useMutation({
    mutationFn: (data) => {
      return userAdd(data.path, { ...data.body });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["users"] });
    },
  });

  const { mutateAsync: doDeleteMutation } = useMutation({
    mutationFn: (id) => {
      return userDelete(id);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["users"] });
      deletedNotyf();
    },
  });

  function onCloseModal() {
    setOpenModal(false);
  }

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const countries = CountryDropdown();

  const { status: statusAdvisors, data: dataAdvisors } = useGetRequest(
    "people/dropdown/advisors/" + companyID,
    {}
  );

  const { status: statusLeaders, data: dataLeaders } = useGetRequest(
    "people/dropdown/leaders/" + companyID,
    {}
  );

  const { status: statusIntroducers, data: dataIntroducers } = useGetRequest(
    "people/dropdown/introducers/" + companyID,
    {}
  );

  if (
    !isLoading &&
    statusAdvisors == "fetched" &&
    statusLeaders == "fetched" &&
    statusIntroducers == "fetched"
  ) {
    return (
      <>
        <div className="flex flex-col p-2 border-2 border-slate-100 rounded-xl">
          <div className="flex flex-row justify-between items-center px-2 mt-2">
            <div>
              <h2 className="text-xl font-semibold leading-7 text-gray-900 px-2 mt-2">
                Users
              </h2>
            </div>

            <button
              type="button"
              onClick={() => setOpenModal(true)}
              class="text-white bg-slate-700 hover:bg-slate-800 focus:ring-4 focus:ring-slate-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-slate-600 dark:hover:bg-slate-700 focus:outline-none dark:focus:ring-slate-800"
            >
              Add User
            </button>
          </div>

          <div className="mt-8 flow-root ml-4 mr-4">
            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                {users?.users.length === 0 ? (
                  <>
                    <Table hoverable className="mb-4">
                      <Table.Head>
                        <Table.HeadCell>Name</Table.HeadCell>
                        <Table.HeadCell>Type</Table.HeadCell>
                        <Table.HeadCell>Email</Table.HeadCell>
                        <Table.HeadCell></Table.HeadCell>
                      </Table.Head>
                      <Table.Body className="divide-y">
                        <Table.Row className="bg-white dark:border-gray-700 dark:bg-gray-800">
                          <Table.Cell className="w-1/4 whitespace-nowrap font-medium text-gray-900 dark:text-white">
                            No Users found
                          </Table.Cell>

                          <Table.Cell className="w-1/4"></Table.Cell>
                          <Table.Cell className="w-2/4"></Table.Cell>
                          <Table.Cell className="w-1/4 flex mr-auto"></Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                  </>
                ) : (
                  <Table hoverable className="mb-4">
                    <Table.Head>
                      <Table.HeadCell>Name</Table.HeadCell>
                      <Table.HeadCell>Type</Table.HeadCell>
                      <Table.HeadCell>Email</Table.HeadCell>
                      <Table.HeadCell></Table.HeadCell>
                    </Table.Head>
                    <Table.Body className="divide-y">
                      {users.users.map((user) => (
                        <Table.Row className="bg-white dark:border-gray-700 dark:bg-gray-800">
                          <Table.Cell className="w-3/10 whitespace-nowrap font-medium text-gray-900 dark:text-white">
                            {user.lastName}, {user.firstName}
                          </Table.Cell>

                          <Table.Cell className="w-3/10">
                            {user.userType == 0 ? (
                              <span className="inline-flex items-center rounded-full bg-pink-50 px-2 py-1 text-xs font-medium text-pink-700 ring-1 ring-inset ring-pink-700/10">
                                No Type Specified
                              </span>
                            ) : null}
                            {user.userType == 1 ? (
                              <span className="inline-flex items-center rounded-full bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">
                                Main
                              </span>
                            ) : null}
                            {user.userType == 2 ? (
                              <span className="inline-flex items-center rounded-full bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/10">
                                Finance
                              </span>
                            ) : null}
                            {user.userType == 3 ? (
                              <span className="inline-flex items-center rounded-full bg-pink-50 px-2 py-1 text-xs font-medium text-pink-700 ring-1 ring-inset ring-pink-700/10">
                                Compliance
                              </span>
                            ) : null}
                          </Table.Cell>
                          <Table.Cell className="w-3/10">
                            {user.email}
                          </Table.Cell>
                          <Table.Cell className="w-1/10 flex justify-end">
                            <a
                              onClick={() => {
                                if (areYouSure(user.userID)) {
                                  userDelete(user.userID);
                                }
                              }}
                              className="text-red-600 hover:text-red-900"
                            >
                              <Button color="failure" size="sm">
                                Delete
                              </Button>
                            </a>
                          </Table.Cell>
                        </Table.Row>
                      ))}
                    </Table.Body>
                  </Table>
                )}
              </div>
            </div>
          </div>
        </div>

        <Modal show={openModal} size="5xl" onClose={onCloseModal} popup>
          <Modal.Header />
          <Modal.Body>
            <div className="space-y-3">
              <h2 class="text-lg font-bold text-gray-900 dark:text-white">
                Add User
              </h2>

              <div className="flex flex-row mt-2">
                <div className="w-1/5 p-1">
                  <label
                    for="main"
                    class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Main
                  </label>
                  <input
                    type="checkbox"
                    id="main"
                    checked={main}
                    onChange={() => {
                      setMain(!main);
                      setFinance(false);
                      setCompliance(false);
                    }}
                    className="align-center h-4"
                  />
                </div>

                <div className="w-1/5 p-1">
                  <label
                    for="finance"
                    class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Finance
                  </label>
                  <input
                    type="checkbox"
                    id="finance"
                    checked={finance}
                    onChange={() => {
                      setMain(false);
                      setFinance(!finance);
                      setCompliance(false);
                    }}
                    className="align-center h-4"
                  />
                </div>

                <div className="w-1/5 p-1">
                  <label
                    for="compliance"
                    class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Compliance
                  </label>
                  <input
                    type="checkbox"
                    id="compliance"
                    checked={compliance}
                    onChange={() => {
                      setMain(false);
                      setFinance(false);
                      setCompliance(!compliance);
                    }}
                    className="align-center h-4"
                  />
                </div>
              </div>

              <div className="flex flex-row">
                <div className="w-1/4 p-1">
                  <label
                    for="firstName"
                    class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    First Name
                  </label>
                  <input
                    type="input"
                    id="firstName"
                    name="firstName"
                    onChange={handleChange}
                    value={inputs.firstName || ""}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    required
                  />
                </div>
                <div className="w-1/4 p-1">
                  <label
                    for="surname"
                    class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Surname
                  </label>
                  <input
                    type="input"
                    id="surname"
                    name="surname"
                    onChange={handleChange}
                    value={inputs.surname || ""}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    required
                  />
                </div>

                <div className="w-1/4 p-1">
                  <label
                    for="email"
                    class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Email
                  </label>
                  <input
                    type="input"
                    id="email"
                    name="email"
                    onChange={handleChange}
                    value={inputs.email || ""}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    required
                  />
                </div>

               
              </div>

              <button
                type="button"
                onClick={async () => {
                  try {
                    await doAddMutation({
                      path: "user/add",
                      body: {
                        companyID: companyID,
                        firstName: inputs.firstName,
                        surname: inputs.surname,
                        email: inputs.email,
                        main: main ? 1 : 0,
                        finance: finance ? 1 : 0,
                        compliance: compliance ? 1 : 0,
                      },
                    });

                    setOpenModal(false);
                    setInputs({});
                    setCompliance(false);
                    setFinance(false);
                    setMain(false);

                    navigate(`/companies/edit/${companyID}`, {
                      replace: true,
                      state: { added: 1 },
                    });
                  } catch (e) {
                    console.log(e);
                  }
                }}
                class="text-white bg-green-500 hover:bg-green-600 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-green-600 dark:hover:bg-slate-600 focus:outline-none dark:focus:ring-green-600"
              >
                Add User
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
